var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCompare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 2.05a.75.75 0 0 1 .75.75v3.115l3.927-.655a.75.75 0 0 1 .774.368l2.863 5.01.02.036c.106.184.197.343.263.516q.087.229.125.47c.028.183.028.366.028.578v.162a3.95 3.95 0 1 1-7.9 0v-.162c0-.212 0-.395.029-.578q.038-.241.125-.47c.065-.173.156-.332.261-.516l.021-.036L13.366 7l-3.229.538-.026.004-3.726.62 2.329 4.076.02.036c.106.184.197.343.263.516q.087.229.125.47c.028.183.028.366.028.578V14a3.95 3.95 0 0 1-7.9 0v-.162c0-.212 0-.395.028-.578q.04-.241.125-.47a3.65 3.65 0 0 1 .263-.516l.02-.036 2.863-5.01a.75.75 0 0 1 .528-.368l4.173-.695V2.8a.75.75 0 0 1 .75-.75M7.31 12.856H3.036L5.2 9.112zm7.49-5.344-2.137 3.837h4.378z",
  clipRule: "evenodd"
})));
SvgCompare.displayName = "SvgCompare";
export { SvgCompare as ReactComponent };
export default SvgCompare;